<template>
  <div>
    <el-dialog
      :visible.sync="myOpen"
      :width="width"
      :show-close="false"
      :custom-class="getClass"
      :top="top"
      :close-on-click-modal="closeOnClickModal"
      :close-on-press-escape="closeOnPressEscape"
      :destroy-on-close = destroy
      :fullscreen="fullscreen"
    >
      <template v-slot:title>
        <slot v-if="!hiddenTitle"  name="title">
          <div class="default-dialog-title-box">
            <el-row>
              <el-col
                  :xs="20"
                  :sm="20"
                  :md="20"
                  :lg="20"
                  :xl="20"
              >
                <h3 class="default-dialog-title">{{ title }}</h3>
              </el-col>
              <el-col
                  :xs="4"
                  :sm="4"
                  :md="4"
                  :lg="4"
                  :xl="4"
              >
                <p
                    class="default-dialog-close text-right"
                    @click="close()"
                >
                  FECHAR
                </p>
              </el-col>
            </el-row>
          </div>
        </slot>
      </template>

      <slot></slot>

      <template v-slot:footer>
        <slot name="footer"></slot>
      </template>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'DialogDefault',
  props: {
    title: {
      type: String,
      default: ''
    },
    destroy: {
      type: Boolean,
      default: false
    },
    open: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: ''
    },
    top: {
      type: String,
      default: '15vh'
    },
    closeOnClickModal: {
      type: Boolean,
      default: true
    },
    closeOnPressEscape: {
      type: Boolean,
      default: true
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    hiddenTitle: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    open (newValue) {
      this.myOpen = newValue
    },
    myOpen (newValue, oldValue) {
      if (newValue !== oldValue && !newValue) {
        this.close()
      }
    }
  },
  data () {
    return {
      myOpen: false
    }
  },
  computed: {
    getClass () {
      if (this.fullscreen) {
        return 'default-dialog-fullscreen'
      }
      return this.hiddenTitle ? 'default-dialog-hidden-title' : 'default-dialog'
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.myOpen = this.open
    },
    close () {
      this.$emit('update:open', false)
      this.$emit('close', false)
    }
  }
}
</script>
<style lang="less">
.default-dialog, .default-dialog-hidden-title {
  background: #FFFFFF 0 0 no-repeat padding-box;
  border-radius: 8px;
  max-height: 90vh;

  .el-dialog__body {
    padding: 10px 20px 30px;
    max-height: 80vh;
    overflow: auto;
  }

  .el-dialog {
    max-height: 90vh;
    z-index: 100000;
    overflow: hidden;
  }

  .default-dialog-title-box {
    padding-bottom: 12px;
    border-bottom: 1px solid #CCCCCC;
  }

  .default-dialog-title {
    font: normal normal 600 24px/29px Open Sans;
    font-weight: 600;
    letter-spacing: 0;
    color: #333333;
  }

  .default-dialog-close {
    font: normal normal 600 13px/16px Open Sans;
    font-weight: 600;
    letter-spacing: 0;
    color: #1074FF;
    cursor: pointer;
  }

  .default-dialog-footer-box {
    padding: 10px;
    border-top: 1px solid #CCCCCC;
  }

  .default-dialog-container {
    overflow: auto;
    max-height: 50vh;
  }
}

.default-dialog-hidden-title {
  .el-dialog__header {
    padding: 0;
  }
}

.default-dialog {
  .el-dialog__header {
    padding: 20px 20px 10px;
  }
}
.default-dialog-fullscreen {
  border-radius: unset;
  max-height: 100vh;
  .el-dialog__header {
    padding: 0;
  }
}
</style>
